import { QueryKey, useQuery as useReactQuery, UseQueryResult } from '@tanstack/react-query'

import { useClient } from '../useClient/useClient'

import { QueryFn, UseQueryOptions } from './useQuery.types'

export const useQuery = <
  TQueryKey extends QueryKey = unknown[],
  TParams = unknown,
  TError = unknown,
  TResponse = TParams
>(
  queryKey: TQueryKey,
  query: QueryFn<TQueryKey, TResponse>,
  options?: UseQueryOptions<TResponse, TError, TResponse, TQueryKey>
): UseQueryResult<TResponse, TError> => {
  const client = useClient()

  return useReactQuery<TResponse, TError, TResponse, TQueryKey>({
    queryKey,
    queryFn: ctx => query(client, ctx.queryKey),
    ...options
  })
}
